import React, { useEffect } from "react";
import { Table, TableContainer } from "@mui/material";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { HubCircularProgress } from "../../components";
import { useGetScheduleOrders } from "../../hooks";
import { getUserLocation } from "../../redux";

import ScheduleTableHeader from "./ScheduleTableHeader";
import ScheduleTableBody from "./ScheduleTableBody";
import { handleScroll } from "./helper";

const Schedule = React.memo(({ defaultLocation = 1 }) => {
  const { isLoading, refetch } = useGetScheduleOrders({ defaultLocation });

  const { search } = useLocation();

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  return isLoading ? (
    <HubCircularProgress centerScreen />
  ) : (
    <TableContainer
      sx={{ backgroundColor: "transparent" }}
      onScroll={handleScroll}
    >
      <Table
        id="ScheduleTable"
        sx={{
          backgroundColor: "hubColors.white",
          borderCollapse: "separate",
          overflow: "clip",
        }}
      >
        <ScheduleTableHeader defaultLocation={defaultLocation} />
        <ScheduleTableBody defaultLocation={defaultLocation} />
      </Table>
    </TableContainer>
  );
});

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export const ScheduleTable = connect(mapStateToProps)(Schedule);
